<template>
  <au-layout class="image-watermark" title="图片水印">
    <template slot="main">
      <waterfall :col="4" :data="album" :gutter-width="20" :is-transition="false">
        <template>
          <el-image v-for="url, index in album" :key="index" :src="url" :preview-src-list="[url]"
            @load="loading = false" @error="loading = false"></el-image>
        </template>
      </waterfall>
    </template>
    <template slot="aside">
      <au-button :loading="loading" @click="getBlackSilk">随机图片</au-button>
      <au-button type="primary">添加水印</au-button>
      <au-button type="danger" @click="handleClean">清空</au-button>
      <el-divider>或</el-divider>
      <el-form ref="form" @submit.native.prevent>
        <el-form-item>
          <au-upload @change="onChange"></au-upload>
        </el-form-item>
      </el-form>
    </template>
  </au-layout>
</template>

<script>
/**
 * @description 图片水印
 * @created 2024/04/28 14:02:11
 */
// api
import { getAnimePicture } from "@/api/xiaoxiao"
export default {
  name: "ImageWatermark",
  data() {
    return {
      show_viewer: false,
      big_image: [],
      album: [],
      loading: false
    }
  },
  methods: {
    async getBlackSilk() {
      this.loading = true
      getAnimePicture("pc").then((result) => {
        if (!result.data) {
          this.$message.error(result.msg)
          this.loading = false
          return
        }
        this.album.push(result.data)
      }).catch(() => {
        this.loading = false
      })
    },
    onChange() {

    },
    handleClean() {
      if (this.album.length === 0) {
        this.$message.warning("图片数据为空，无需清空！")
        return
      }
      this.$confirm("该操作会清空整个图片数据，且不可恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.album = []
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.image-watermark {
  .vue-waterfall {
    height: 100%;
  }

  .el-image {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
